/**
 * Check is the Local Storage ready. It is possible that the WPF wrapper
 * renders app/page before Local Storage is populated.
 */
export function isLocalStorageReady(): boolean {
  try {
    return !!localStorage.getItem('_token');
  } catch (error) {
    return false;
  }
}
